import $ from 'jquery';
import Swiper from 'swiper';
import './../../node_modules/retinajs';
import Cookies from 'js-cookie';
import './../../node_modules/jquery.smooth-scroll';


$(document).ready(function () {
    // Cookies
    if (Cookies.get('policyNotification') == 'true') {

    } else {
        // #
        // Cookies.set('policyNotification', 'true', { expires: 500 });
        setTimeout(function () {
            $('#cookie-policy-alert').addClass('shown');
        }, 1000);
    }
    $('#close-cookies-btn').click(function (event) {
        Cookies.set('policyNotification', 'true', {expires: 500});
    });
    // wordpress helpers
    if ($('ul').is('#menu-mobile')) {
        $('ul#menu-mobile a').addClass('anchorLink');
    }
    if ($('ul').is('#footer-menu-left')) {
        $('ul#footer-menu-left a').addClass('anchorLink');
    }
    if ($('ul').is('#footer-menu-right')) {
        $('ul#footer-menu-right a').addClass('anchorLink');
    }

    // wordpress helpers end
    $('#close-cookies-btn').click(function (event) {
        $('#cookie-policy-alert').removeClass('shown')
    });


    // main page logo link
    $('.header-logo, .footer-logo').click(function (event) {
        window.location = "/";
    });

    // navigation
    $('#btn-nav,#btn-nav-close').click(function (event) {
        $('.menu-mobile').toggleClass('shown');
    });

    // click area monitoring (mobile menu)
    $(document).on('click touchstart', function (e) {
        var mobileMenu = $(".menu-mobile");
        var btnShowMenu = $("#btn-nav");
        if (!mobileMenu.is(e.target) &&
            mobileMenu.has(e.target).length === 0 &&
            !btnShowMenu.is(e.target) &&
            btnShowMenu.has(e.target).length === 0) {
            $(".menu-mobile").removeClass('shown');
        }
    });


    // active states mobile menu on scroll
    if ($('body').hasClass('page-main')) {
        $(window).on('load resize', function () {
            var pos_intro = $('#intro').offset().top - 120;
            var pos_services = $('#services').offset().top - 120;
            var pos_features = $('#features').offset().top - 120;
            var pos_industries = $('#industries').offset().top - 120;
            var pos_api = $('#api').offset().top - 120;
            var pos_apply = $('#apply').offset().top - 120;

            $(window).scroll(function () {
                if ($(this).scrollTop() >= pos_intro && $(this).scrollTop() < pos_services) {
                    $('.menu-mobile a').removeClass('active');
                    $('.menu-mobile a[href="#intro"]').addClass('active');
                } else if ($(this).scrollTop() >= pos_services && $(this).scrollTop() < pos_features) {
                    $('.menu-mobile a').removeClass('active');
                    $('.menu-mobile a[href="#services"]').addClass('active');
                } else if ($(this).scrollTop() >= pos_features && $(this).scrollTop() < pos_industries) {
                    $('.menu-mobile a').removeClass('active');
                    $('.menu-mobile a[href="#features"]').addClass('active');
                } else if ($(this).scrollTop() >= pos_industries && $(this).scrollTop() < pos_api) {
                    $('.menu-mobile a').removeClass('active');
                    $('.menu-mobile a[href="#industries"]').addClass('active');
                } else if ($(this).scrollTop() >= pos_api && $(this).scrollTop() < pos_apply) {
                    $('.menu-mobile a').removeClass('active');
                    $('.menu-mobile a[href="#api"]').addClass('active');
                } else if ($(this).scrollTop() >= pos_apply) {
                    $('.menu-mobile a').removeClass('active');
                    $('.menu-mobile a[href="#apply"]').addClass('active');
                } else {
                    $('.menu-mobile a').removeClass('active');
                }
            });
        });
    }

    // sliders
    if ($('div').is('#apply')) {
        var initialSlide_position = $('.swiper-slide-first-position').index();

        // slider Dates
        var swiperDates = new Swiper('.event-dates .swiper-container', {
            initialSlide: initialSlide_position,
            slidesPerView: 6,
            spaceBetween: 46,
            allowTouchMove: false,
            breakpoints: {
                991: {
                    slidesPerView: 4,
                    spaceBetween: 46,
                },
                767: {
                    slidesPerView: 4,
                    spaceBetween: 46,
                },
                639: {
                    slidesPerView: 2,
                    spaceBetween: 46,
                }
            }
        });

        // slider Events
        var swiperEvents = new Swiper('.slider-event .swiper-container', {
            initialSlide: initialSlide_position,
            allowTouchMove: false,
            init: false,
            navigation: {
                nextEl: '.swiper-btn-next',
                prevEl: '.swiper-btn-prev',
            },
            breakpoints: {
                1200: {
                    allowTouchMove: true,
                }
            }
        });

        // Buttons
        $('.btn-next').click(function (event) {
            swiperEvents.slideNext();
        });

        $('.btn-prev').click(function (event) {
            swiperEvents.slidePrev();
        });

        // InitialSlide
        swiperEvents.on('init', function () {
            $('.event-dates .first-visible-date .month i ').text($('.event-dates .swiper-slide-active .month i').text());
            $('.event-dates .first-visible-date .year i ').text($('.event-dates .swiper-slide-active .year i').text());
            if (swiperDates.realIndex == swiperEvents.realIndex) {
                $('.event-dates .first-visible-date').addClass('active');
                $('.event-dates .swiper-slide-active').addClass('active');
            } else {
                $('.event-dates .swiper-slide:nth-child(' + (swiperEvents.realIndex + 1) + ')').addClass('active');
            }
        });
        swiperEvents.init();

        // Resize
        swiperEvents.on('resize', function () {
            swiperDates.slideTo(swiperEvents.realIndex);
            if (swiperDates.realIndex == swiperEvents.realIndex) {
                $('.event-dates .first-visible-date').addClass('active');
                $('.event-dates .first-visible-date .month i').text($('.event-dates .swiper-slide:nth-child(' + (swiperDates.realIndex + 1) + ') .month i').text());
                $('.event-dates .first-visible-date .year i').text($('.event-dates .swiper-slide:nth-child(' + (swiperDates.realIndex + 1) + ') .year i').text());
            } else {
                $('.event-dates .first-visible-date').removeClass('active');
                $('.event-dates .first-visible-date .month i').text($('.event-dates .swiper-slide:nth-child(' + (swiperDates.realIndex + 1) + ') .month i').text());
                $('.event-dates .first-visible-date .year i').text($('.event-dates .swiper-slide:nth-child(' + (swiperDates.realIndex + 1) + ') .year i').text());
            }
        });

        // slideChange
        swiperEvents.on('slideChange', function () {
            $('.event-dates .swiper-slide').removeClass('active');
            if (swiperDates.realIndex == swiperEvents.realIndex) {
                swiperDates.slideTo(swiperEvents.realIndex);
                $('.event-dates .first-visible-date .month i').text($('.event-dates .swiper-slide:nth-child(' + (swiperDates.realIndex + 1) + ') .month i').text());
                $('.event-dates .first-visible-date .year i').text($('.event-dates .swiper-slide:nth-child(' + (swiperDates.realIndex + 1) + ') .year i').text());
                $('.event-dates .swiper-slide:nth-child(' + (swiperEvents.realIndex + 1) + ')').addClass('active');

            } else {
                swiperDates.slideTo(swiperEvents.realIndex);
                $('.event-dates .first-visible-date .month i').text($('.event-dates .swiper-slide:nth-child(' + (swiperDates.realIndex + 1) + ') .month i').text());
                $('.event-dates .first-visible-date .year i').text($('.event-dates .swiper-slide:nth-child(' + (swiperDates.realIndex + 1) + ') .year i').text());
                $('.event-dates .swiper-slide:nth-child(' + (swiperEvents.realIndex + 1) + ')').addClass('active');
            }

            if (swiperDates.realIndex == swiperEvents.realIndex) {
                $('.event-dates .first-visible-date').addClass('active');
            } else {
                $('.event-dates .first-visible-date').removeClass('active');
            }
        });

        // click
        $('.event-dates .swiper-slide ').click(function (event) {
            swiperDates.slideTo($(this).index());
            swiperEvents.slideTo($(this).index());
        });
    }

    // Mailchimp
    ajaxMailChimpForm($("#subscribe-form"), $("#subscribe-result"));
    // Turn the given MailChimp form into an ajax version of it.
    // If resultElement is given, the subscribe result is set as html to
    // that element.
    function ajaxMailChimpForm($form, $resultElement) {
        // Hijack the submission. We'll submit the form manually.
        $form.submit(function (e) {
            e.preventDefault();
            if (!isValidEmail($form)) {
                var error = "A valid email address must be provided.";
                $resultElement.html(error);
                $resultElement.css("color", "red");
                $resultElement.css("display", "block");
            } else {
                $resultElement.css("color", "black");
                $resultElement.css("display", "block");
                $resultElement.html("Subscribing...");
                submitSubscribeForm($form, $resultElement);
            }
        });
    }

    // Validate the email address in the form
    function isValidEmail($form) {
        // If email is empty, show error message.
        // contains just one @
        var email = $form.find("input[type='email']").val();
        if (!email || !email.length) {
            return false;
        } else if (email.indexOf("@") == -1) {
            return false;
        }
        return true;
    }

    // Submit the form with an ajax/jsonp request.
    // Based on http://stackoverflow.com/a/15120409/215821
    function submitSubscribeForm($form, $resultElement) {
        $.ajax({
            type: "GET",
            url: $form.attr("action"),
            data: $form.serialize(),
            cache: false,
            dataType: "jsonp",
            jsonp: "c", // trigger MailChimp to return a JSONP response
            contentType: "application/json; charset=utf-8",
            error: function (error) {
                // According to jquery docs, this is never called for cross-domain JSONP requests
            },
            success: function (data) {
                if (data.result != "success") {
                    var message = data.msg || "Sorry. Unable to subscribe. Please try again later.";
                    $resultElement.css("color", "red");
                    if (data.msg && data.msg.indexOf("already subscribed") >= 0) {
                        message = "You're already subscribed. Thank you.";
                        $resultElement.css("color", "black");
                        $resultElement.css("display", "block");
                    }
                    $resultElement.html(message);
                } else {
                    $resultElement.css("color", "black");
                    $resultElement.css("display", "block");
                    $resultElement.html("Thank you!<br>You must confirm the subscription in your inbox.");
                }
            }
        });
    }

    // Mailchimp end


    // smooth scroll
    if ($('body').is('.page-text')) {
        $(document).on('click', 'a.anchorLink', function (e) {
            e.preventDefault();
            Cookies.set('anchorPosition', $(this).attr('href'));
            window.location.href = 'https://unifiedfinance.com';
            return false;
        });
    }

    if ($('body').is('.page-main')) {
        $('a.anchorLink').smoothScroll({offset: -100});
        if (Cookies.get('anchorPosition') == '#intro') {
            setTimeout(function () {
                $.smoothScroll({scrollTarget: '#intro', offset: -100});
            }, 800);
        }
        ;
        if (Cookies.get('anchorPosition') == '#services') {
            setTimeout(function () {
                $.smoothScroll({scrollTarget: '#services', offset: -100});
            }, 800);
        }
        ;
        if (Cookies.get('anchorPosition') == '#features') {
            setTimeout(function () {
                $.smoothScroll({scrollTarget: '#features', offset: -100});
            }, 800);
        }
        ;
        if (Cookies.get('anchorPosition') == '#industries') {
            setTimeout(function () {
                $.smoothScroll({scrollTarget: '#industries', offset: -100});
            }, 800);
        }
        ;
        if (Cookies.get('anchorPosition') == '#api') {
            setTimeout(function () {
                $.smoothScroll({scrollTarget: '#api', offset: -100});
            }, 800);
        }
        ;
        if (Cookies.get('anchorPosition') == '#apply') {
            setTimeout(function () {
                $.smoothScroll({scrollTarget: '#apply', offset: -100})
            }, 800);
        }
        ;
        Cookies.set('anchorPosition', '');
    }


    // smooth scroll end

});